import React from 'react';

import FormSubmitButtonGroup from './FormSubmitButtonGroup.jsx';


const FormSubmitRow = ({ children, ...props }) => (
  <div style={{ marginTop: '20px' }}>
    <FormSubmitButtonGroup { ...props }>{children}</FormSubmitButtonGroup>
  </div>
);

export default FormSubmitRow;
